import { useEffect, useState } from 'react';
import { formatNumber, toFuelLPerNm, rangeNm } from '@boatnav/core';
import { useBoatStore } from './boatStore.js';
import { BoatForm } from './BoatForm.js';
import { StackHeader } from '../../lib/StackHeader.js';
import type { Boat } from '../../lib/db.js';
import { msg } from '../../lib/messages.js';
import './boat.css';

function summaryLine(b: Boat): string {
  const lPerNm = toFuelLPerNm(b.fuelValue, b.fuelUnit, b.cruiseKn);
  return `marsj ${formatNumber(b.cruiseKn, 0)} kn · ${formatNumber(lPerNm, 1)} l/nm`;
}

export function BoatScreen(): JSX.Element {
  const { boats, activeBoatId, loaded, load, setActive } = useBoatStore();
  const [editing, setEditing] = useState<Boat | 'new' | null>(null);

  useEffect(() => {
    if (!loaded) void load();
  }, [loaded, load]);

  return (
    <div className="boat-screen">
      <div className="screen-inner">
        <StackHeader title={msg.boat.title} />

        {boats.length === 0 ? (
          <p className="boat-screen__empty">{msg.boat.empty}</p>
        ) : (
          <ul className="boat-list">
          {boats.map((b) => (
            <li key={b.id} className="boat-card">
              <button
                type="button"
                className={`boat-card__radio${b.id === activeBoatId ? ' boat-card__radio--on' : ''}`}
                aria-label={msg.boat.setActive}
                onClick={() => void setActive(b.id)}
              />
              <button type="button" className="boat-card__body" onClick={() => setEditing(b)}>
                <div className="boat-card__name">{b.name}</div>
                <div className="boat-card__summary numeral">{summaryLine(b)}</div>
                {b.tankL != null && b.tankL > 0 && (
                  <div className="boat-card__range">
                    {msg.boat.range}: {formatNumber(rangeNm(b.tankL, toFuelLPerNm(b.fuelValue, b.fuelUnit, b.cruiseKn)), 0)} nm
                  </div>
                )}
              </button>
            </li>
          ))}
        </ul>
      )}

        <button type="button" className="btn btn--accent boat-screen__add" onClick={() => setEditing('new')}>
          {msg.boat.add}
        </button>
      </div>

      {editing && (
        <BoatForm
          boat={editing === 'new' ? null : editing}
          canDelete={boats.length > 1}
          onClose={() => setEditing(null)}
        />
      )}
    </div>
  );
}
